import React from 'react'; import ExtendedModulePage from './ExtendedModulePage'; export default function ContactSubmissionsPage(){return <ExtendedModulePage moduleKey="contact-submissions"/>}
